import { useQuery } from "react-query";
import { get_performance } from "../../../faunadb/queries/performance";

export default function usePerformanceDetail(client, id) {
    return useQuery(["performance", id], () => get_performance(client, id), { refetchOnWindowFocus: false })
}